export enum EDmcaFormObjects {
	DMCA_CASE = 'dmcaCase',
	INDIVIDUAL = 'individual',
	LEGAL_ENTITY = 'legalEntity',
	CONFIRMATIONS = 'confirmations',
}